import * as React from 'react'
import loadable from '@loadable/component'

import { spacing, styled } from '@thg-commerce/gravity-theme'
import { Button } from '@thg-commerce/gravity-elements'

const InfoIcon = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/StoreInfo'),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

export const ClickAndCollectButton = styled(Button)<{ isFullWidth?: boolean }>`
  ${(props) => props.isFullWidth && 'width: 100%'};
  padding-left: 0;
  &:hover {
    padding-left: 0;
  }
`

export const StyledInfoIcon = styled(InfoIcon)`
  path:first-of-type {
    fill: ${(props) => props.theme.colors.palette.brand.dark};
  }
  margin-right: ${spacing(1)};
`
